import { Box, Link, makeStyles, Typography } from "@material-ui/core";
import { COMMS_MODULE_NAME, CTR_MODULE_NAME } from "../moduleName";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { authSelector } from "../redux/selectors";
import { UserType } from "../redux/types";

const useStyles = makeStyles((theme) => ({
  link: {
    display: "flex",
    alignItems: "center",
    fontSize: "1.1em",
    marginBottom: 30,
  },
  h1: {
    fontSize: "2.5rem",
    marginBottom: "25px",
  },
  h2: {
    fontSize: "1.25rem",
    marginBottom: "50px",
    fontWeight: 300,
  },
  h3: {
    fontSize: "1.25rem",
    marginBottom: "25px",
    fontWeight: 400,
  },
  h33: {
    fontSize: "1.25rem",
    marginTop: "50px",
    marginBottom: "25px",
    fontWeight: 400,
  },
  option: {
    // paddingLeft: 25,
  },
  hr: {
    marginTop: 50,
  },
  box: {
    border: "2px solid #ddd",
    padding: 15,
    backgroundColor: "#eee",
  },
}));

export const NotificationErrorRenderer: React.FC<{ error: any }> = ({
  error,
}) => {
  const classes = useStyles();

  const { userType } = useAuth(authSelector);

  return (
    <>
      {userType && userType === UserType.AO ? (
        <>
          <Typography className={classes.h1}>Something went wrong</Typography>
          <Typography className={classes.h2} variant="h2">
            It looks like you have been removed or unable to access the request.
            If you think this was done in error please raise a new contact the
            requlator request.
            <Link
              underline="always"
              href={COMMS_MODULE_NAME + "/" + CTR_MODULE_NAME}
            >
              {" "}
              Click here{" "}
            </Link>
            or reload the page and try again.
          </Typography>
        </>
      ) : (
        <>
          <Typography className={classes.h1}>Not Authorized</Typography>
          <Typography className={classes.h2} variant="h2">
            You are not authorized to view this recipient
          </Typography>

          <Typography className={classes.h33} variant="h3">
            Detailed error information
          </Typography>

          <Box className={classes.box}>
            <code>{JSON.stringify(error, undefined, 2)}</code>
          </Box>
        </>
      )}
    </>
  );
};

export const notificationErrorRenderer = (error: any) => {
  const isAuthHttpError =
    error &&
    error.opts.method === "GET" &&
    Number(error.status) === 401 &&
    error.url.includes("informationrequests");

  if (!isAuthHttpError) {
    return null;
  }
  return <NotificationErrorRenderer error={error} />;
};
